import { UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query'
import { errorHandler } from '@/shared/lib/errorHandler'
import { CreatePromotionFormState } from '../model/types'
import { UploadPromotionPhoto } from '@/entities/Photos/api/photo-promotion'
import { Promotion, topliApi } from '@/shared/api/topli/TopliApi'
import { formatDateForSending } from '@/shared/lib/utils'
import { currentPromotionByIdQueryKey, promotionListsByPageQueryKey } from '@/entities/Promotions'

export const createPromotion = async (state: CreatePromotionFormState): Promise<any> => {
  const { start_date, end_date, is_permanent, thumbnail, residential_projects, ...restState } =
    state

  const body = {
    start_date: formatDateForSending(start_date) as string,
    end_date: is_permanent ? null : formatDateForSending(end_date),
    is_permanent,
    residential_projects: residential_projects?.map(item => Number(item)),
    ...restState,
  }

  const response = await topliApi.promotions.create({ item_id: null }, body)
  return response
}

export const useCreatePromotionApi = (): UseMutationResult<
  Promotion,
  Error,
  CreatePromotionFormState
> => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: state => createPromotion(state),
    onSuccess: async (res, state) => {
      try {
        if (state.thumbnail && typeof state.thumbnail === 'object') {
          await UploadPromotionPhoto({
            file: state.thumbnail,
            id: res.id,
          })
        }

        await Promise.all([
          queryClient.invalidateQueries({
            queryKey: [promotionListsByPageQueryKey],
            refetchType: 'active',
          }),
          queryClient.invalidateQueries({
            queryKey: [currentPromotionByIdQueryKey],
            refetchType: 'active',
          }),
        ])
      } catch (error) {
        errorHandler(error)
      }
    },
  })
}
